module.exports = __webpack_public_path__ + "media/images/img_search03-a2e3dcff960f373ffda27a72a3469b99.png";